const cinternoitems = {

  background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

  links: [
    { texto: "", url: "" },
    { texto: "", url: "" },
    { texto: "", url: "" },
    { texto: "", url: "" },
    { texto: "", url: "" }
  ],

  pdfs: [
    {
      id: 1,
      tituloTexto: "Asignación de espacios gratuitos, para la venta y exhibición de artesanías en el pabellón artesanal y gastronómico artesanal de la Feria San Francisco Pachuca 2026",
      descripcion: "",
      tituloPdf: "",
      url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/conv/2026/CONVOCATORIA_ASIGNACION_DE_ESPACIOS_FS.pdf"
    },
  ]

};

export default cinternoitems;